import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "tailwindcss/tailwind.css";

import { Dialog } from "primereact/dialog";
import useFetchData from "../../../../repo/get";
import { useLocation } from "react-router-dom";
import usePutData from "../../../../repo/put";
import ReactHowler from "react-howler";
import positiveSound from "../../../../assets/positive.mp3";
import negativeSound from "../../../../assets/negative.mp3";
import { MultiSelect } from 'primereact/multiselect'
import FichaPesquisa from "components/hooks/FichaDetails";

const dateData = (data) => {
  if (data === "hoje") return -3;
  if (data === "depois") return -1;
  if (data === "vencida") return -3;
  if (data === "amanha") return -2;
  return 0;
};

const CardDataTable = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const dataFilter = searchParams.get("data");
  const datef = new Date();
  const currentTimezoneOffsetInHours = datef.getTimezoneOffset() / 60;
  const brazilTimezoneOffsetInHours = -3;
  const offsetDifferenceInHours = brazilTimezoneOffsetInHours - currentTimezoneOffsetInHours;
  const newDate = new Date(datef.getTime() + offsetDifferenceInHours * 60 * 60 * 1000);
  const ano = newDate.getFullYear();
  const mes = newDate.getMonth() + 1;
  const dia = newDate.getDate() + dateData(dataFilter);

  const adjustedDia = dia > 0 ? dia : 1;
  const date = `${ano}-${mes < 10 ? '0' + mes : mes}-${adjustedDia < 10 ? '0' + adjustedDia : adjustedDia}`;

  const baseSelect = localStorage.getItem("baseSelected") || "";
  const cargoSelect = localStorage.getItem("cargo") || "";

  const { data: fetchedData } = useFetchData(`api/romaneios/getMinimalAll/aguardando/${baseSelect}`);
  const [data, setData] = useState([]);
  const [selectedFicha, setSelectedFicha] = useState(null);
  const [error, setError] = useState(null);
  const [codigoRomaneio, setCodigoRomaneio] = useState("");
  const [playSound, setPlaySound] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [regionOptions, setRegionOptions] = useState([]);
  const [entregadorOptions, setEntregadorOptions] = useState([]);
  const [filters, setFilters] = useState({
    'codigoUid': { value: null, matchMode: 'contains' },
    'data': { value: null, matchMode: 'contains' },
    'local': { value: null, matchMode: 'contains' },
    'entregador': { value: null, matchMode: 'contains' },
    'empresa': { value: null, matchMode: 'equals' },
  });
  const { putData } = usePutData();

  useEffect(() => {
    if (fetchedData) {
      const formattedData = fetchedData.map(item => ({
        ...item,
        codigoUid: item.codigoUid,
        data: item.data.replace("T", " ").split(".")[0],
        empresa: item.empresa,
        entregador: item.entregador,
        funcionario: item.funcionario,
        local: item.cidade,
        sts: item.status,
      }));

      const uniqueRegions = [
        ...new Set(fetchedData.map(item => item.cidade))
      ];
      const uniqueEntregador = [
        ...new Set(fetchedData.map(item => item.entregador))
      ];
      setRegionOptions(uniqueRegions);
      setEntregadorOptions(uniqueEntregador);


      console.log("Unique Regions:", date);
      const filterByDate = (item) => {
        const itemDate = item.data.split(" ")[0];
        if (dataFilter === "hoje") {
          return itemDate === date;
        } else if (dataFilter === "amanha") {
          return itemDate === date;
        } else if (dataFilter === "depois") {
          return itemDate >= date;
        } else if (dataFilter === "vencida") {
          return itemDate < date;
        }
        return true;
      };



      const filteredData = formattedData.filter(filterByDate);
      if (cargoSelect === "ENTREGADOR") {

        setData(filteredData.filter(func => func.entregador === localStorage.getItem("nome")));
      } else {
        setData(filteredData);
      }
    }
  }, [fetchedData, date, dataFilter]);


  const onRowSelect = (e) => {
    setSelectedFicha(e.data);
  };

  const closeDetails = () => {
    setSelectedFicha(null);
  };
  const handleAdicionarRomaneio = async () => {
    if (!codigoRomaneio) {
      setError("Por favor, preencha o código do romaneio.");
      setPlaySound(negativeSound);
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await putData(`api/romaneios/update/codigo/${codigoRomaneio}`, {
        motorista: 0,
        status: "aguardando",
        funcionario: localStorage.getItem("id"),
        base: localStorage.getItem("baseSelected")
      });

      if (response && response.message) {
        setError(response.message);
        setPlaySound(negativeSound);
      } else if (response && response.id) {
        const newRomaneio = {
          id: response.id,
          codigoUid: response.codigoUid,
          quantidade: response.quantidade,
          empresa: response.empresa.nome,
          entregador: response.entregador.nome,
          endereco: response.entregador.endereco,
          funcionario: response.funcionario.nome,
          local: response.cidade.map((cidade) => cidade.nome).join(', '),
          base: response.base.nome,
          sts: response.sts,
          codigos: response.codigos,
          telefone: response.entregador.telefone,
          linkDownload: response.linkDownload,
          data: response.data.replace("T", " ").split(".")[0] || new Date().toISOString(),
        };

        setData((prevData) => {
          const exists = prevData.some((item) => item.id === newRomaneio.id);
          if (exists) { return prevData; }
          return [newRomaneio, ...prevData];
        });

        setPlaySound(positiveSound);
        setError("");

      } else {
        setError("Erro desconhecido ao tentar atualizar o romaneio.");
        setPlaySound(negativeSound);
      }
    } catch (err) {
      setError("Erro ao atualizar romaneio.");
      setPlaySound(negativeSound);
    } finally {
      setIsSubmitting(false);
      setCodigoRomaneio("");
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && !isSubmitting) {
      event.preventDefault();
      handleAdicionarRomaneio();
    }
  };
  const header = (
    <div className="table-header">
      <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white p-6">
        <div className="flex flex-col md:flex-row  items-center justify-between">
          <h1 className="text-2xl font-bold p-component">
            ROMANEIOS EM BASE
          </h1>
          {cargoSelect !== "ENTREGADOR" && (
            <input
              type="text"
              placeholder="Adicionar romaneio ..."
              value={codigoRomaneio}
              onChange={(e) => setCodigoRomaneio(e.target.value)}
              onKeyDown={handleKeyDown}
              className="p-inputtext p-component rounded-md shadow px-4 py-4 p-input-icon-left border border-black h-full"
            />
          )}
        </div>
      </div>
      {cargoSelect !== "ENTREGADOR" && (
        <div className="flex justify-between items-center w-full">
          <div className="flex flex-col md:flex-row  justify-between space-x-4">
            {/* Filtro de Entregador */}
            <MultiSelect
              value={filters.entregador.value}
              options={entregadorOptions.map(entregador => ({ label: entregador, value: entregador }))}
              onChange={(e) => setFilters({ ...filters, entregador: { value: e.value, matchMode: 'in' } })}
              placeholder="Entregador"
              className="bg-lightBlue-200 p-input-icon-left md:w-14rem border border-black h-full font-bold"
              filter
              filterPlaceholder="Buscar entregador..."
              filterBy="label"
            />

            {/* Filtro de Local */}
            <MultiSelect
              value={filters.local.value}
              options={regionOptions.map(local => ({ label: local, value: local }))}
              onChange={(e) => setFilters({ ...filters, local: { value: e.value, matchMode: 'in' } })}
              placeholder="Local de destino"
              className="bg-lightBlue-200 p-input-icon-left md:w-14rem border border-black h-full font-bold"
              filter
              filterPlaceholder="Buscar local..."
              filterBy="label"
            />

          </div>

          {/* Botão de Limpar Filtros */}
          <Button
            onClick={() => setFilters({
              local: { value: null, matchMode: 'equals' },
              entregador: { value: null, matchMode: 'equals' }
            })}
            icon="pi pi-refresh"
            className="bg-red-500 text-white px-3 py-1 m-2 rounded-md shadow hover:bg-red-600 font-bold"
          >
          </Button>
        </div>

      )}
      <p><strong>&#8203;</strong></p>
      <div className="flex flex-col md:flex-row  justify-between items-center w-full">
        <span className="p-input-icon-left">
          <InputText
            type="search"
            onInput={(e) => {
              const value = e.target.value;
              setFilters((prevFilters) => ({
                ...prevFilters,
                global: { value, matchMode: 'contains' }
              }));
            }}
            placeholder="Buscar..."
          />
        </span>
        {/* Filtro de Região */}

        <h4 className="p-input-icon-right text-2xl uppercase font-bold text-blueGray-700 ml-auto">
          {data.length} Sacas Em Base
        </h4>
      </div>
    </div>
  );

  return (
    <>


      <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white p-6">
        {selectedFicha && (
          <Dialog header="Detalhes da Ficha" visible={true} style={{ width: '70%' }} onHide={closeDetails}>
            <FichaPesquisa ficha={selectedFicha.codigoUid} />
          </Dialog>

        )}

        <DataTable
          value={data}
          paginator
          rows={10}
          stripedRows
          rowsPerPageOptions={[5, 10, 25, 50, 100, 300, 99999]}
          tableStyle={{ minWidth: "50rem" }}
          selectionMode="single"
          onRowSelect={onRowSelect}
          filters={filters}
          globalFilterFields={['codigoUid', 'data', 'local', 'entregador', 'empresa']}
          emptyMessage="Nenhum resultado encontrado."
          header={header}
        >
          <Column
            field="codigoUid"
            header="Código de Ficha"
            sortable
            style={{ minWidth: '12rem', fontSize: '13px' }}
          />

          <Column
            field="data"
            header="Data de Criação"
            sortable
            style={{ minWidth: '12rem', fontSize: '13px' }}
          />
          <Column
            field="empresa"
            header="Empresa"
            sortable
            style={{ minWidth: '12rem', fontSize: '13px' }}
          />
          <Column
            field="local"
            header="Local"
            sortable
            style={{ minWidth: '12rem', fontSize: '13px' }}
          />
          <Column
            field="entregador"
            header="Entregador"
            sortable
            style={{ minWidth: '12rem', fontSize: '13px' }}
          />

        </DataTable>


        {error && <p className="text-red-500">{error}</p>}
        {playSound && <ReactHowler src={playSound} playing={true} onEnd={() => setPlaySound(null)} />}
      </div>
    </>
  );

}

export default CardDataTable;
